export default function lang(state = 'fr', action) {
  if (action.type === 'setLanguage') {
    if (action.language) return action.language;
  } else {
    return state;
  }
}